import { createActions, createAction } from 'redux-actions'

export const { onboarding }: any = createActions({
  ONBOARDING: {
    /** Handled by saga: @see store/entities/onboarding/saga/changeProTrack */
    CHANGE_PRO_TRACK: proTrackLevelId => ({ proTrackLevelId }),
    CHANGE_IS_LOADING: isLoading => ({ isLoading }),
  },
})

export const triggerAddMobileNumber = createAction('ONBOARDING/TRIGGER_ADD_MOBILE_NUMBER')
